import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

import { ILot } from './../../../models/generic';
import {
  IContractIds,
  IFieldOrder,
  IManualBatchContractFilter
} from './../../../models/manual-batch';
import { ApiManualBatchService } from './../../../services/api/api-manual-batch.service';
import { SnackbarService } from './../../../services/snackbar.service';
import { IContractLot, IPagination } from 'src/app/models/generic';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import {
  DialogTypeEnum,
  IDialogConfirm
} from 'src/app/models/dialog';

@Component({
  selector: 'app-contract-list-manual-dialog',
  templateUrl: './contract-list-manual-dialog.component.html',
  styleUrls: ['./contract-list-manual-dialog.component.scss']
})
export class ContractListManualDialogComponent implements OnInit {
  contracts: IContractLot[] = [];
  fieldsOrder: IFieldOrder[] = [];
  hasSearched: boolean = false;
  contractsFilter: IManualBatchContractFilter = {
    Skip: 0,
    Take: 50,
    Bank: '',
    BeneficiaryType: '',
    Beneficiary: '',
    Channel: '',
    ContractStatus: '',
    Text: '',
    FieldsOrder: []
  };

  count: number = 0;
  queryField: FormControl<string> = new FormControl<string>('', {
    nonNullable: true
  });

  invoiceDateFrom = new FormControl<string>('', { nonNullable: true });
  invoiceDateTo = new FormControl<string>('', { nonNullable: true });

  constructor(
    private _manualBatchService: ApiManualBatchService,
    public _dialogRef: MatDialogRef<ContractListManualDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ILot,
    private _snackbarService: SnackbarService,
    private _dialogService: ApiDialogService
  ) { }

  ngOnInit(): void {
    this.resetContractsResult();
  }

  searchFields(searchFields: IManualBatchContractFilter): void {
    this.contractsFilter = {
      ...this.contractsFilter,
      ...searchFields
    };

    this.contractsFilter.Skip = 0;

    this.getContractsByFilter();
  }

  orderChange(fieldsOrder: IFieldOrder[]): void {
    this.contractsFilter = {
      ...this.contractsFilter,
      FieldsOrder: [...fieldsOrder]
    };

    if (!this.hasSearched) {
      return;
    }

    this.getContractsByFilter(false, {
      Skip: 0,
      Take: this.contractsFilter.Skip! + this.contractsFilter.Take!
    });
  }

  handlePagination(pagination: IPagination): void {
    if (!this.hasSearched) {
      return;
    }

    this.contractsFilter = {
      ...this.contractsFilter,
      ...pagination
    };

    this.getContractsByFilter(true);
  }

  handleSearchField(searchValue: string): void {
    this.contractsFilter.Text = searchValue;
    this.contractsFilter.Skip = 0;
    this.getContractsByFilter();
  }

  getContractsByFilter(pushContracts: boolean = false, pagination?: IPagination): void {

    let filter: IManualBatchContractFilter = {
      ...this.contractsFilter,
      InvoiceDateFrom: this.invoiceDateFrom.value,
      InvoiceDateTo: this.invoiceDateTo.value
    };

    if (pagination) {
      filter = { ...filter, ...pagination };
    }

    if (!this.hasSearchCriteria(filter)) {
      this.hasSearched = false;
      this.resetContractsResult();
      return;
    }

    this.hasSearched = true;

    this._manualBatchService.getContractsManualBatch(filter).subscribe({
      next: (response) => {
        this.count = response.Count;

        if (pushContracts) {
          this.contracts.push(...response.Data);
        } else {
          this.contracts = [...response.Data];
        }
      }
    });
  }

  private hasSearchCriteria(filter: IManualBatchContractFilter): boolean {
    return !!(
      (filter.Text ?? '').trim() ||
      (filter.Bank ?? '').trim() ||
      (filter.BeneficiaryType ?? '').trim() ||
      (filter.Beneficiary ?? '').trim() ||
      (filter.Channel ?? '').trim() ||
      (filter.ContractStatus ?? '').trim() ||
      (filter.InvoiceDateFrom ?? '').trim() ||
      (filter.InvoiceDateTo ?? '').trim()
    );
  }

  private resetContractsResult(): void {
    this.contracts = [];
    this.count = 0;
  }

  handleInsertContracts(): void {
    const { contractIds } = this._manualBatchService.selectedContracts.value;
    if (contractIds.length > 0) {
      if (this.data?.BatchId) {
        this.insertContracts();
      } else {
        this.handleManualBatch();
      }
    } else {
      this._snackbarService.openSnackBar(
        'Nenhum contrato foi selecionado',
        'warning'
      );
    }
  }

  insertContracts(): void {
    const { contractIds } = this._manualBatchService.selectedContracts.value;
    const exceptionContractIds =
      this._manualBatchService.exceptionsContracts.value.contractIds;
    let contracts: IContractIds = {
      BatchId: this.data.BatchId.toString(),
      ContractIds: contractIds,
      ExceptionsContractIds: exceptionContractIds,
      Filter: { ...this.contractsFilter },
      AllContracts: false
    };

    if (this.validateHeaderFlag(contracts.ContractIds)) {
      contracts.ContractIds = [];
      contracts.AllContracts = true;
    }

    this._manualBatchService.addContractsManualBatch(contracts).subscribe({
      next: (response) => {
        this.closeModal(response);
      }
    });
  }

  validateHeaderFlag(contractIds: string[]): boolean {
    const checkFlag: boolean = contractIds.includes('all');

    return checkFlag;
  }

  closeModal(batch?: ILot): void {
    this.fieldsOrder = [];
    this._manualBatchService.resetContracts();
    this._dialogRef.close(batch);
  }

  handleManualBatch(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Gerar novo lote',
        title: 'Caso prossiga, um novo lote será gerado. Deseja continuar?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.createManualBatch();
      }
    });
  }

  createManualBatch(): void {
    this._manualBatchService.createManualBatch().subscribe({
      next: (response) => {
        if (response) {
          this.data = response;
          this.insertContracts();
        }
      }
    });
  }
}
